// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1EV8e","list":"BalanceDue_list__3GBf-","listRow":"BalanceDue_listRow__2wilX","total":"BalanceDue_total__3u0pP"};